<div class="switcher-wrapper" *ngIf="_$sites | async as sites">
    <h5 [innerHTML]="'generalTerms.countrySelectionTitle' | translate"></h5>
    <div *ngIf="sites && sites.length > 0" class="select-wrapper">
        <select #s="ngModel" (change)="onSelect(s.value)" [(ngModel)]="selectedValue">
            <option *ngFor="let item of sites" [value]="item.site">
                <span *ngIf="item.enabled === true"></span>{{ item.name }}
                <span *ngIf="item.languages && item.languages.length > 1 && item.enabled === true">({{ item.languages[0].language }})</span>
            </option>
        </select>
    </div>
</div>
